module.exports = __webpack_public_path__ + "static/icon-game-2c9bcd9fdc345b63805b0708a6b25e08.png";